import { useNavigate } from 'react-router-dom';
import { useGoogleLogin } from '@react-oauth/google';
import axios from 'axios';
import { BASE_URL } from '@utils/constants';
import { SsoRowButton } from './SsoRowButton';
import { CheckCircleBoldIcon, GoogleLoginIcon } from '@src/svg';
import React, { FC } from 'react';
import { logger } from '@utils/logger';
import { homePathForVersions } from '@routes/helpers';
import { useAppSelector } from '@store/hooks';
import { selectUsers } from '@store/slices/users/usersSlice';
import { toastError } from '@utils/helpers';
import { toastMessage } from '@utils/toastMessage';

type GoogleSignInButtonProps = {
  type?: 'attach' | 'basic' | 'row';
  activated?: boolean;
};

export const newTargetUrl = window.location.origin.includes('localhost')
  ? 'https://legacy.curavel.online'
  : window.location.origin;

//TODO request must be moved to RTK Query
export const GoogleSignInButton: FC<GoogleSignInButtonProps> = ({
  type = 'basic',
  activated = false,
}) => {
  const { userType } = useAppSelector(selectUsers);
  const navigate = useNavigate();
  const login = useGoogleLogin({
    onSuccess: (response) => {
      if (response?.code) {
        sessionStorage.setItem('sso_in_progress', 'true');
        axios
          .post(
            `${BASE_URL}/auth/google`,
            { code: response.code },
            { withCredentials: true }
          )
          .then(() => {
            sessionStorage.removeItem('sso_in_progress');
            navigate(homePathForVersions[userType]);
          })
          .catch((error) => {
            sessionStorage.removeItem('sso_in_progress');
            toastError(error, toastMessage.AUTH.noAccountLinkedToGoogle);
          });
      }
    },
    onError: () => {
      logger.log('Login Failed');
    },
    flow: 'auth-code',
    redirect_uri: `${newTargetUrl}/google/callback`,
    scope: 'openid email profile',
  });

  if (type === 'row') {
    return (
      <SsoRowButton
        provider="Google"
        icon={<GoogleLoginIcon />}
        activated={activated}
        onClick={login}
      />
    );
  }

  return (
    <button
      className="social_button"
      type="button"
      onClick={login}
      disabled={activated && type !== 'basic'}
    >
      <GoogleLoginIcon />
      {type !== 'attach'
        ? ''
        : activated
          ? 'Google SSO Activated'
          : 'Setup Google SSO'}
      {type === 'basic' && 'Sign in with Google'}
      {activated && type !== 'basic' && (
        <span className="sso-activated-icon">
          <CheckCircleBoldIcon width={24} height={24} />
        </span>
      )}
    </button>
  );
};
